import { h } from 'preact'

export const OccasionnelONews = (props) => {
   try {
      const { advCanal, url, recoZone, isAdvise, offerSpecificationCode, parentOfferSpecificationCode, alt, idc, images, adv_tracker, cacheKey } = props[0]

      let pdbIdc
      let cappingAdv
      if (isAdvise) {
         pdbIdc = offerSpecificationCode
         if (parentOfferSpecificationCode !== '') {
            pdbIdc += ',' + parentOfferSpecificationCode
         }
         cappingAdv = {
            'data-adv-canal': advCanal,
            'data-adv-cappingdata': `{'m': '${offerSpecificationCode}','p': '${parentOfferSpecificationCode}','t': '${adv_tracker}'}`,
         }
      } else {
         pdbIdc = idc
      }
      return (
         <a
            href={url}
            class="d-block"
            data-pdb-zid={recoZone}
            data-pdb-sc={isAdvise ? 'adv' : 'mpt'}
            data-pdb-idc={pdbIdc}
            data-pdb-vi={isAdvise ? `${images.urlImageResize}${images.img103}` : images.img1}
            data-pdb-ta={isAdvise ? adv_tracker : ''}
            {...cappingAdv}
            data-cache-key={cacheKey ? cacheKey : ''}
            data-oevent-category="news_foisonnement-b"
            data-oevent-action={alt}
            data-oevent-label={url}
            data-oevent-other={`{"track_refZ":"${recoZone}"}`}
         >
            {isAdvise ? (
               <picture>
                  <source srcset={`${images.urlImageResize}${images.img103}?format=480x310&saveas=webp`} media="(max-width: 1199px)" />
                  <img src={`${images.urlImageResize}${images.img103}?crop=480,310,0,39&saveas=webp`} alt={alt} loading="lazy" />
               </picture>
            ) : (
               <picture>
                  <source srcset={images.img1} media="(max-width: 1199px)" />
                  <img src={images.img1} alt={alt} loading="lazy" />
               </picture>
            )}
         </a>
      )
   } catch (error) {
      console.error('occasionnel-onews.jsx', error)
   }
}
